export const ArticlesIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="10"
        fill="white"
        style={{fill: 'white', fillOpacity: 1}}
      />
      <path
        d="M23 16H25M23 20H25M25 24H15M15 16V20H19V16H15ZM13 28H27C27.5304 28 28.0391 27.7893 28.4142 27.4142C28.7893 27.0391 29 26.5304 29 26V14C29 13.4696 28.7893 12.9609 28.4142 12.5858C28.0391 12.2107 27.5304 12 27 12H13C12.4696 12 11.9609 12.2107 11.5858 12.5858C11.2107 12.9609 11 13.4696 11 14V26C11 26.5304 11.2107 27.0391 11.5858 27.4142C11.9609 27.7893 12.4696 28 13 28Z"
        stroke="url(#paint0_linear_11058_1198)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_11058_1198"
          x1="20"
          y1="12"
          x2="20"
          y2="28"
          gradientUnits="userSpaceOnUse"
        >
          <stop style={{stopColor: 'black', stopOpacity: 1}} />
          <stop
            offset="1"
            stopColor="#666666"
            style={{stopColor: '#666666', stopOpacity: 1}}
          />
        </linearGradient>
      </defs>
    </svg>
  );
};
